export interface ArticleItem {
  id: string;
  title: string;
  excerpt: string;
  author: string;
  time: string;
  reads: string;
  tag: string;
  category: string;
}

export interface Category {
  key: string;
  name: string;
  en: string;
  desc: string;
  icon: string;
  accent: string;
}

export const categories: Category[] = [
  { key: "yanshi", name: "演员情史", en: "ROMANCE", desc: "聚光灯下的爱情与离散，梳理当红与经典演员的情感轨迹。", icon: "ri-heart-3-line", accent: "text-primary-600" },
  { key: "juzu", name: "剧组风波", en: "BACKSTAGE", desc: "片场轶事、拍摄内幕与团队协作的台前幕后。", icon: "ri-clapperboard-line", accent: "text-accent-600" },
  { key: "pianchou", name: "明星片酬", en: "SALARY", desc: "行业薪酬观察，解读头部与腰部演员的市场定价逻辑。", icon: "ri-coin-line", accent: "text-foreground-600" },
  { key: "tishen", name: "替身真相", en: "STUNTS", desc: "动作替身、武行与高难度场面的职业世界。", icon: "ri-run-line", accent: "text-primary-500" },
  { key: "shuadapai", name: "耍大牌现场", en: "DIVA", desc: "舆论热议的敬业与傲慢，还原事件的前因后果。", icon: "ri-vip-crown-2-line", accent: "text-accent-700" },
  { key: "zhengrong", name: "颜值风云", en: "LOOKS", desc: "围绕形象管理的讨论，客观呈现传闻与本人回应。", icon: "ri-user-smile-line", accent: "text-foreground-500" },
];

export interface BreakingStory {
  id: string;
  title: string;
  lead: string;
  img: string;
  tag: string;
}

export const heroStories: BreakingStory[] = [
  {
    id: "h1",
    title: "片场实录：一场夜戏背后的12小时与数百次重来",
    lead: "凌晨的摄影棚里，灯光师与武行正在做最后调试。这条五分钟的镜头，凝聚了整个团队一整天的较真。",
    img: "https://readdy.ai/api/search-image?query=film%20studio%20night%20shoot%20set%20with%20cinema%20lights%20and%20camera%20crane%2C%20crew%20silhouettes%20working%20under%20warm%20amber%20practical%20lights%2C%20editorial%20documentary%20photography%2C%20atmospheric%20haze%2C%20cinematic%20warm%20tones&width=1600&height=900&seq=hero-film-01&orientation=landscape",
    tag: "剧组独家",
  },
  {
    id: "h2",
    title: "替身演员的双面人生：从无人知晓到被看见",
    lead: "飞檐走壁的威亚、贴身的爆破点，成就主角高光时刻的，常是一群把名字藏起来的职业人。",
    img: "https://readdy.ai/api/search-image?query=action%20stunt%20double%20actor%20on%20wire%20harness%20in%20film%20studio%2C%20professional%20dramatic%20lighting%2C%20editorial%20cinematic%20portrait%2C%20warm%20and%20dark%20tones%2C%20high%20detail&width=1600&height=900&seq=hero-stunt-02&orientation=landscape",
    tag: "替身专栏",
  },
  {
    id: "h3",
    title: "片酬之外：演员市场价值是如何被评估的？",
    lead: "从热度指数到商务报价，行业如何为一张脸和一份演技定价？我们拆解薪酬背后的计算方式。",
    img: "https://readdy.ai/api/search-image?query=modern%20conference%20room%20overhead%20meeting%20documents%20and%20charts%2C%20warm%20desk%20lamp%20light%2C%20editorial%20business%20photography%2C%20professional%20warm%20tone%2C%20no%20people&width=1600&height=900&seq=hero-salary-03&orientation=landscape",
    tag: "行业观察",
  },
];

export interface FeedItem {
  title: string;
  tag: string;
  time: string;
  hot: string;
}

export const newsTicker: string[] = [
  "年度演技口碑榜启动，2026季风潮悄然升温",
  "动作组威亚工装升级，高空戏份安全标准再提高",
  "多部年代剧同期开机，现实主义题材回暖",
  "行业发布薪酬倡议，呼吁建立透明片酬参照体系",
  "影视基地武行培训机构报名量同比上涨",
  "古装大剧杀青特辑曝光，幕后团队获观众致敬",
];

export const hotBoard: FeedItem[] = [
  { title: "三位新锐演员凭口碑剧集体出圈，经纪人却被网友考古", tag: "热度", time: "20分钟前", hot: "128.6w" },
  { title: "年代大戏拍摄三个月，主演为角色增重又减重的幕后", tag: "片场", time: "45分钟前", hot: "96.2w" },
  { title: "替身演员自述：那场威亚戏我看清了整个机房", tag: "替身", time: "1小时前", hot: "88.9w" },
  { title: "票房与口碑之外，导演坦言最怕的是辜负创作", tag: "访谈", time: "2小时前", hot: "74.5w" },
  { title: "从默默无闻到家喻户晓，这代演员的等待清单", tag: "人物", time: "3小时前", hot: "63.1w" },
  { title: "剧组化妆间的半小时：演员出戏与入戏的分界点", tag: "幕后", time: "4小时前", hot: "52.7w" },
  { title: "一份迟到十年的道歉，让行业重新讨论敬业", tag: "讨论", time: "5小时前", hot: "45.3w" },
  { title: "童星长大后的职业转型，是光环还是枷锁", tag: "成长", time: "6小时前", hot: "38.8w" },
];

export const featuredColumn: ArticleItem = {
  id: "col-1",
  title: "给角色让路：这代演员如何重新定义'专业'",
  excerpt: "有人为一场戏提前三个月进组，有人在高温棚里一遍遍重来。当我们谈论'敬业'时，谈的其实是演员与角色之间彼此成就的关系。本刊走访多位幕后从业者，还原职业精神在当下的具体模样。",
  author: "编辑部",
  time: "2026.09.06",
  reads: "18.2万",
  tag: "深读",
  category: "行业观察",
};

export interface ArticleMap {
  [cat: string]: ArticleItem[];
}

export const categoryArticles: ArticleMap = {
  yanshi: [
    { id: "y1", title: "当红演员的恋爱公开时刻：选择背后是对粉丝的交代", excerpt: "公开恋情从来不只是两个人的事，也关乎作品、形象与观众期待。我们复盘近几年几段有代表性的公开时刻。", author: "柳絮", time: "2026.09.05", reads: "21.4万", tag: "情史观察", category: "演员情史" },
    { id: "y2", title: "因戏结缘与戏终人散：片场爱情的现实温差", excerpt: "荧幕里的火花延伸到现实，往往要面对档期、聚少离多与舆论的多重考验。", author: "阿禾", time: "2026.09.04", reads: "15.7万", tag: "情感盘点", category: "演员情史" },
    { id: "y3", title: "低调到极致：这几位演员如何守住感情隐私", excerpt: "在人人追问的时代，沉默反而成了最稀缺的表达方式。", author: "编辑部", time: "2026.09.02", reads: "9.3万", tag: "人物侧写", category: "演员情史" },
  ],
  juzu: [
    { id: "j1", title: "一场群戏拍了四天：团队如何弥合创作分歧", excerpt: "分歧并非矛盾的全部，更多时候是不同专业视角在寻找同一种表达。", author: "陈默", time: "2026.09.05", reads: "12.8万", tag: "片场日志", category: "剧组风波" },
    { id: "j2", title: "导演与制片人吵翻了？我们还原真相", excerpt: "所谓'剧组不和'，往往被过度娱乐化。现场的真实，比戏剧本身更克制。", author: "一川", time: "2026.09.03", reads: "18.1万", tag: "辟谣手记", category: "剧组风波" },
    { id: "j3", title: "杀青时刻：为什么每个剧组都会集体落泪", excerpt: "数十个日夜的并肩，让'剧组'成了比血缘更紧密的临时家庭。", author: "编辑部", time: "2026.09.01", reads: "7.9万", tag: "幕后", category: "剧组风波" },
  ],
  pianchou: [
    { id: "p1", title: "片酬的分层真相：头部与腰部演员之间的鸿沟", excerpt: "舆论关注的是天价数字，而行业真实是金字塔底层的普遍等待。", author: "数据组", time: "2026.09.05", reads: "26.3万", tag: "薪酬观察", category: "明星片酬" },
    { id: "p2", title: "流媒体时代，演员收入结构发生了哪些变化", excerpt: "平台报价、分账与商务代言正在重塑演员的价值公式。", author: "方晴", time: "2026.09.03", reads: "14.9万", tag: "行业拆解", category: "明星片酬" },
    { id: "p3", title: "片酬与演技成正比吗？一次务实的行业对谈", excerpt: "当市场开始为专业买单，'值不值'就变成了可量化的命题。", author: "编辑部", time: "2026.08.30", reads: "11.2万", tag: "深度对谈", category: "明星片酬" },
  ],
  tishen: [
    { id: "t1", title: "威亚之下的信任：武行与主演如何完成高难动作", excerpt: "每一个漂亮的转身背后，都是一次次地面演练与空中校准。", author: "铁牛", time: "2026.09.04", reads: "19.5万", tag: "职业速写", category: "替身真相" },
    { id: "t2", title: "从龙套到武术指导，他的二十年片场岁月", excerpt: "那些没上字幕的名字，构成了华语动作片最坚实的底盘。", author: "老周", time: "2026.09.02", reads: "13.4万", tag: "人物", category: "替身真相" },
    { id: "t3", title: "危险镜头谁来拍？行业安全标准正在被重新书写", excerpt: "技术进步与制度完善，让'替身'二字的意义不再被误读。", author: "一川", time: "2026.08.29", reads: "10.7万", tag: "行业观察", category: "替身真相" },
  ],
  shuadapai: [
    { id: "s1", title: "'耍大牌'传闻背后，藏着怎样被误读的细节", excerpt: "档期冲突、健康状态、工作节奏，很多'耍大牌'其实是职业考量的错位表达。", author: "小鹿", time: "2026.09.05", reads: "22.6万", tag: "还原现场", category: "耍大牌现场" },
    { id: "s2", title: "哪些行为是真的傲慢？业内人士的坦诚看法", excerpt: "我们采访了多位场务与副导演，聊了聊'傲慢'在片场真正的样子。", author: "编辑部", time: "2026.09.03", reads: "16.8万", tag: "行业调查", category: "耍大牌现场" },
    { id: "s3", title: "职业素养的下限与上限：一次文明拍片倡议", excerpt: "越来越多人意识到，尊重是协作的基础，也是作品的底色。", author: "方晴", time: "2026.09.01", reads: "8.6万", tag: "倡议", category: "耍大牌现场" },
  ],
  zhengrong: [
    { id: "z1", title: "关于形象管理的传闻，我们整理了一份完整回应清单", excerpt: "面对外界猜测，当事人的回应方式与时效，往往比传闻本身更能说明问题。", author: "晓知", time: "2026.09.04", reads: "24.1万", tag: "盘点", category: "颜值风云" },
    { id: "z2", title: "用作品说话：为什么实力才是最有力的澄清", excerpt: "真正立得住的形象，从来靠角色与作品持续加分。", author: "编辑部", time: "2026.09.02", reads: "12.3万", tag: "观点", category: "颜值风云" },
    { id: "z3", title: "舆论场里的'颜值'争论，该怎样理性讨论", excerpt: "把审美议题拉回尊重与专业的轨道，是每个围观者都能做的事。", author: "阿禾", time: "2026.08.31", reads: "9.8万", tag: "讨论", category: "颜值风云" },
  ],
};

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  { q: "51影院的内容信息来源可靠吗？", a: "我们的内容以剧组公开物料、官方公告、行业媒体交叉报道与当事人回应为基础进行整理，并尽量对信息来源做标注。娱乐资讯本身存在演绎成分，我们会持续以核实、克制的态度呈现，也欢迎读者对存疑内容提出反馈。" },
  { q: "为什么有些'爆料'没有点名？", a: "对未经证实的网络传闻，我们优先以保护当事人权益为原则，不对模糊信息进行指名道姓的扩散。涉及真名时，通常仅出现在已有官方确认或公开可查证的事件中。" },
  { q: "如何投稿爆料或提供线索？", a: "你可以通过页脚的联系表单提交线索。为方便核实，请尽量提供时间、场合与可公开检索的依据。编辑部会审核素材的真实性与价值，不会采用明显侵权或恶意攻击的内容。" },
  { q: "会为剧组宣传或艺人团队做有偿投放吗？", a: "51影院坚持采编与商务分离的原则。我们不会以删帖、修改报道为条件收取费用，所有合作均以显著标注的方式呈现，确保内容与商业边界清晰。" },
  { q: "内容更新频率是怎样的？", a: "我们会结合行业动态与读者关注话题滚动更新，通常每天推送多篇原创盘点与观察文章，并在热搜发生时第一时间推出专题。" },
  { q: "如何联系51影院进行商务合作？", a: "品牌、平台或机构合作可通过页脚商务邮箱与我们取得联系，我们会根据内容契合度评估是否合作，并严格遵守行业自律规范。" },
];

export const editorialValues = [
  { icon: "ri-search-eye-line", title: "多方核实", desc: "一条线索到手，先查证、再落笔，宁可慢一点也不以讹传讹。" },
  { icon: "ri-shield-check-line", title: "尊重边界", desc: "报道对象首先是普通人，隐私与人格尊严始终是写作的前提。" },
  { icon: "ri-article-line", title: "克制表达", desc: "用事实与逻辑说话，拒绝标题党与无底线煽动情绪。" },
  { icon: "ri-chat-follow-up-line", title: "开放求证", desc: "欢迎当事人与读者指正，让讨论在理性中不断靠近真相。" },
];